import React from 'react';

import { Box, InputAdornment, Typography } from '@material-ui/core';

import { TextValidatorComponent } from 'components/FormComponents';
import { getMinMaxValidatedValue } from 'utils';

import { ColorPicker } from '../ColorPicker/ColorPicker';

import { IFrameCaption } from '../OverlayCloseButtonSettings/style';

interface BackdropSettings {
  backgroundColor: string;
  opacity: number;
  blur: number;
}

interface OverlayBackdropSettingsProps {
  settings: BackdropSettings;
  onChange: (settings: BackdropSettings) => void;
}

export const OverlayBackdropSettings = ({ settings, onChange }: OverlayBackdropSettingsProps) => {
  const handleChange = (value: string, field: 'opacity' | 'blur') => {
    const sanitizedValue = value.replace(/[^0-9]/g, '');
    const numericValue = sanitizedValue ? Number(sanitizedValue) / 100 : 0;
    const validatedValue = getMinMaxValidatedValue(numericValue, { min: 0, max: 1 });

    onChange({ ...settings, [field]: validatedValue });
  };

  return (
    <>
      <Box mb={4}>
        <Typography variant="h4" display="inline">
          Overlay Background UI
        </Typography>
      </Box>
      <Box mb={5}>
        <IFrameCaption>Manage background behind overlays.</IFrameCaption>
      </Box>
      <Box display="flex" style={{ gap: '16px' }}>
        <ColorPicker
          setColor={({ hex }) => onChange({ ...settings, backgroundColor: hex })}
          color={{ hex: settings.backgroundColor }}
        />
        <TextValidatorComponent
          disableMinHeight
          value={Math.round(settings.opacity * 100)}
          label="Opacity"
          fieldName="value"
          handleChange={({ value }: { value: string }) => handleChange(value, 'opacity')}
          fullWidth={false}
          InputProps={{
            inputProps: { min: 0, max: 100 },
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          InputLabelProps={{
            shrink: true,
          }}
          style={{ width: '100px', marginTop: '3px' }}
        />
        <TextValidatorComponent
          disableMinHeight
          value={Math.round(settings.blur * 100)}
          label="Blur"
          fieldName="value"
          handleChange={({ value }: { value: string }) => handleChange(value, 'blur')}
          fullWidth={false}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          InputLabelProps={{
            shrink: true,
          }}
          style={{ width: '67px', marginTop: '3px' }}
        />
      </Box>
    </>
  );
};
